import CostBudgetVendorSelection from '@/features/offers/offer-detail/components/CostBudgetVendorSelection'
import useVendor from '@/features/vendors/useVendor'
import { Flex, Text } from '@chakra-ui/react'
import { useWatch } from 'react-hook-form'
import { usePRAccess } from '../PRAccessProvider'
import PRVendorDetailTab from './PRVendorDetailTab'

const VendorSelectionSubTab = ({ costBudgetIndex, vendorSelectionIndex }) => {
  const { canSelectVendor } = usePRAccess()

  const vendorSelections = useWatch({ name: `sourcing.costBudgets.${costBudgetIndex}.PR.vendorSelections` }) ?? []
  const costBudgetName = useWatch({ name: `sourcing.costBudgets.${costBudgetIndex}.detail.purpose` })
  const RFQNumber = useWatch({ name: `sourcing.costBudgets.${costBudgetIndex}.detail.RFQCode` })

  const selectedVendor = vendorSelections[vendorSelectionIndex]?.vendor

  const { useVendorOptions } = useVendor()
  const { data: vendorOptions } = useVendorOptions({ valueKey: '_id' })

  const canEditVendorSelection = canSelectVendor(costBudgetIndex, vendorSelectionIndex)

  return (
    <>
      <Flex mb="3" gap="6" wrap="wrap">
        <Text fontSize="lg">
          <Text as="b" color="black">
            {(costBudgetName || `Cost Budget ${costBudgetIndex + 1}`) + ' - ' + (RFQNumber || '-')}
          </Text>
        </Text>
      </Flex>

      <CostBudgetVendorSelection
        costBudgetIndex={costBudgetIndex}
        selectionPath={`sourcing.costBudgets.${costBudgetIndex}.PR.vendorSelections.${vendorSelectionIndex}`}
        selectionLabel={`PR Technical Selection ${vendorSelectionIndex + 1}`}
        canSelectQuotation={canEditVendorSelection}
        canSelectionVendor={canEditVendorSelection}
        canBeReference={false}
        hasRemark={true}
        shouldSetQuotationDetails={true}
      />
      {selectedVendor && (
        <PRVendorDetailTab costBudgetIndex={costBudgetIndex} vendorSelectionIndex={vendorSelectionIndex} />
      )}
    </>
  )
}

export default VendorSelectionSubTab
